<template>
  <el-row :gutter="20" style="height: 100%; margin-bottom: 0" type="flex">
    <el-col :lg="7" :md="9" style="height: 100%">
      <ChatSessionSummary @refreshSummary="refreshSummary" />
    </el-col>
    <el-col :lg="17" :md="15" style="height: 100%">
      <AgentSessionDetails />
    </el-col>
  </el-row>
</template>

<script>
import { GRAPHQL_WEBSOCKET_STATE, listenGraphQLWebsocket } from "@/store/api";
import { notifyWebsocketReconnected } from "@/helperMethods/notifyError";
import { isFunction } from "@/helperMethods/util";
import ChatSessionSummary from "@/views/Supervisor/ChatSessionSummary";
import AgentSessionDetails from "@/views/Supervisor/AgentSessionDetails";

export default {
  data() {
    return {
      currentMode: "",
      selectedChatSession: null,
      currentExpanded: null,
    };
  },
  components: {
    ChatSessionSummary,
    AgentSessionDetails,
  },
  methods: {
    refreshSummary() {
      this.$store.dispatch("supervisor/FETCH_AGENTS_WITH_CHAT_COUNT", {
        email: this.$store.state.profile.email,
      })
      .then(() => {
        this.$store.dispatch('supervisor/SHOW_ONLINE_AGENTS');
      });
      this.$store.dispatch("supervisor/SHOW_AGENT_LIST", { status: null });
      this.$store.commit("supervisor/SET_SELECTED_CHAT_SESSION", null);
      this.fetchChats();
    },
    fetchChats() {
      this.fetchInQueueChats();
      this.fetchOnGoingChats();
      this.fetchAbandonedChats();
      this.fetchResolvedChats();
    },
    fetchInQueueChats() {
      this.$store.dispatch("supervisor/FETCH_IN_QUEUE_CHATS");
    },
    fetchOnGoingChats() {
      this.$store.dispatch("supervisor/FETCH_ON_GOING_CHATS");
    },
    fetchAbandonedChats() {
      this.$store.dispatch("supervisor/FETCH_ABANDONED_CHATS");
    },
    fetchResolvedChats() {
      this.$store.dispatch("supervisor/FETCH_RESOLVED_CHATS");
    },
  },
  mounted() {
    this.fetchChats();
    this.unsubcribleWSReconnectedEvent = listenGraphQLWebsocket(
      GRAPHQL_WEBSOCKET_STATE.RECONNECTED,
      () => {
        notifyWebsocketReconnected();
        this.fetchChats();
      }
    );
  },
  beforeDestroy() {
    this.$store.dispatch("supervisor/FLUSH_SUPERVISOR_DATA");
    isFunction(this.unsubcribleWSReconnectedEvent) && this.unsubcribleWSReconnectedEvent();
  },
};
</script>
